
import { ProductGroup } from "@/models/base/product-group";
import { ProductGroupService } from "@/services/product-group-service";
import Vue from "vue";
import AppProductGroupEdit from "./ProductGroupsEdit.vue";

export default Vue.extend({
	data(){
		return {
			topLevelFolders: [] as ProductGroup[]
		};
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			await ProductGroupService.updateGroups(this.topLevelFolders);
			this.close();
		},
		onInput(topLevelFolders:ProductGroup[]){
			this.topLevelFolders = topLevelFolders;
		}
	},
	components: {
		AppProductGroupEdit
	},
	i18nEx: {
		componentPrefix: "components.products"
	},
});
